import zaludGeneralQuestions, {
  ZaludGeneralQuestionFieldAnswers
} from './general/questions';
import zaludNoseSinusesQuestions, {
  ZaludNoseSinusesQuestionFieldAnswers
} from './noseSinuses/questions';
import zaludThroatPainQuestions, {
  ZaludThroatPainQuestionFieldAnswers
} from './throatPain/questions';
import zaludColdFluQuestions, {
  ZaludColdFluQuestionFieldAnswers
} from './coldFlu/questions';
import zaludPinkEyeQuestions, {
  ZaludPinkEyeQuestionFieldAnswers
} from './pinkEye/questions';
import zaludEarInfectionQuestions, {
  ZaludEarInfectionQuestionFieldAnswers
} from './earInfection/questions';
import zaludStiTreatmentQuestions, {
  ZaludStiTreatmentQuestionFieldAnswers
} from './stiTreatment/questions';
import zaludUtiTreatmentQuestions, {
  ZaludUtiTreatmentQuestionFieldAnswers
} from './utiTreatment/questions';
import zaludYeastInfectionQuestions, {
  ZaludYeastInfectionQuestionFieldAnswers
} from './yeastInfection/questions';
import zaludBacterialVaginosisQuestions, {
  ZaludBacterialVaginosisQuestionFieldAnswers
} from './bacterialVaginosis/questions';

const ZaludQuestions = [
  ...zaludGeneralQuestions,
  ...zaludNoseSinusesQuestions,
  ...zaludThroatPainQuestions,
  ...zaludColdFluQuestions,
  ...zaludPinkEyeQuestions,
  ...zaludEarInfectionQuestions,
  ...zaludStiTreatmentQuestions,
  ...zaludUtiTreatmentQuestions,
  ...zaludYeastInfectionQuestions,
  ...zaludBacterialVaginosisQuestions
];
export default ZaludQuestions;

export type ZaludQuestionFieldAnswers = ZaludGeneralQuestionFieldAnswers &
  ZaludNoseSinusesQuestionFieldAnswers &
  ZaludThroatPainQuestionFieldAnswers &
  ZaludColdFluQuestionFieldAnswers &
  ZaludPinkEyeQuestionFieldAnswers &
  ZaludEarInfectionQuestionFieldAnswers &
  ZaludStiTreatmentQuestionFieldAnswers &
  ZaludUtiTreatmentQuestionFieldAnswers &
  ZaludYeastInfectionQuestionFieldAnswers &
  ZaludBacterialVaginosisQuestionFieldAnswers;
